import RestEdit from 'containers/rest/Edit';
import Form from '../components/Form';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import crudSelectors from '@redux/crudSelectors';
import _, { flatten, groupBy, mapValues, omit } from 'lodash';

export default function Edit() {
  const currData = useSelector<DynamicObjectType>(
    (state) => state.roles.currentData,
  );

  const dataPermissions = useSelector<DynamicObjectType[]>(
    crudSelectors.rolePermissionGroups.getDataRecordArr,
  );

  const breadcrumbs = [
    {
      title: 'Roles',
      href: '/rolePermissions',
    },
    {
      title: `#${currData?.id}`,
    },
  ];

  const formatRoles = flatten(
    dataPermissions?.map((item) => {
      const sub = flatten(
        item?.subRolePermissionGroups?.map((subItem) => {
          if (subItem?.rolePermissions?.length > 0)
            return subItem?.rolePermissions;
        }),
      );
      return sub;
    }),
  )?.filter((item) => !!item);

  const groupData = groupBy(
    currData?.rolePermissions,
    (item) => item?.group?.id,
  );

  const formatData = () => {
    const sub = {};
    dataPermissions?.map((item) => {
      item?.subRolePermissionGroups?.map((subItem) => {
        if (subItem?.rolePermissions?.length > 0) {
          return (sub[subItem?.id] = []);
        }
      });
    });
    return sub;
  };

  const handleDataConvert = (record) => {
    return {
      ...record,
      rolePermissions: {
        ...formatData,
        ...mapValues(groupData, (value) => value.map((item) => item?.id)),
      },
    };
  };

  return (
    <RestEdit
      model="roles"
      breadcrumbs={breadcrumbs}
      apiOptions={{
        isRequestApi: true,
      }}
      formatOnSubmit={(values) => {
        const roleValues = values?.rolePermissions;
        const initRoleValues = mapValues(groupData, (value) =>
          value.map((item) => item?.id),
        );
        const result = _.mergeWith(
          {},
          roleValues,
          initRoleValues,
          (objValue) => {
            if (_.isArray(objValue)) {
              return objValue;
            }
          },
        );

        const role = _.values(result);

        return {
          ...omit(values, 'rolePermissions'),
          rolePermissions: formatRoles
            ?.filter((item: DynamicObjectType) =>
              flatten(role)?.includes(item?.id),
            )
            ?.map((item: DynamicObjectType) => ({
              id: Number(item?.id),
            })),
        };
      }}
      handleDataConvert={handleDataConvert}
    >
      <Form />
    </RestEdit>
  );
}
